module.exports = __webpack_public_path__ + "media/images/costumes/top/logo/logo-4-1c28e4821afb2e9d8e47dd46f1cb739e.png";